'use es6';

import DateLabel from 'conversations-visitor-message-history/dates/DateLabel';
import { connect } from 'react-redux';
import { getWidgetDataLanguage } from '../../../widget-data/selectors/widgetDataSelectors';
const mapStateToProps = state => {
  return {
    locale: getWidgetDataLanguage(state)
  };
};
export default connect(mapStateToProps, null)(DateLabel);